import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { resolver } from 'app/services/resolver';
import { taxRulesService } from 'app/services/taxRulesService/taxRulesService';
import { ecoTaxService } from 'app/services/ecoTaxService/ecoTaxService';
import { Workstation } from 'app/services/fmsrService/fmsr.types';
import { itemsSearchService } from 'app/services/itemsSearchService/itemsSearchService';
import { fmsrService } from 'app/services/fmsrService/fmsrService';
import { rtkQueryErrorLogger } from 'app/services/interceptors/errorLogger';
import { adapter } from 'app/services/adapters';
import { authInterceptor, tenantIdInterceptor } from 'app/services/interceptors';
import { reducer } from './reducer';

const urlParams = new URLSearchParams(window.location.search);

export const middleware = [
  itemsSearchService.middleware,
  taxRulesService.middleware,
  ecoTaxService.middleware,
  fmsrService.middleware,
  rtkQueryErrorLogger,
];

const configStore = () => {
  const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
    preloadedState: {
      workstation: {
        countryCode: urlParams.get('countryCode'),
        businessUnitId: urlParams.get('businessUnitId'),
        workstationId: urlParams.get('workstationId'),
        tenantId: urlParams.get('tenantId'),
        operatorId: urlParams.get('operatorId'),
        jwt: localStorage.getItem('fmsrToken') || '',
      } as Workstation,
    },
  });
  resolver.setStore(store);
  return store;
};

const store = configStore();

adapter.interceptors.request.use(authInterceptor(store));
adapter.interceptors.request.use(tenantIdInterceptor(store));

export type RootState = ReturnType<typeof store.getState>;
export type FMSRStore = typeof store;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export default store;
